export default {
  APP_URL: '/page/appointment/api/',
  // Dev version
  // CAPTCHA_KEY: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
  // Production version
  CAPTCHA_KEY: '6LfGI8sSAAAAAEDMRjBBrecnxsHXT_RvyGBP3oUj',
  ...process.env,
};
